export default __webpack_public_path__ + "static/media/tileSetter.98808864.jpg";